import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import Icon from '../../../components/icon'
import styles from './volunteerList.module.scss'

export default function CheckInOutInfoModal({ show, onHide }) {
  const { t } = useTranslation()

  return (
    <>
      {show && <div className={styles.nestedModalBackdrop} onClick={onHide} />}
      <Modal 
        show={show} 
        onHide={onHide} 
        size="md" 
        centered
        className={styles.nestedModal}
        backdrop={false}
      >
      <Modal.Header closeButton>
        <Modal.Title>
          {t('VolunteerListScreen.check_in_out_info.title', 'How to manage Check In/Out of Volunteers')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className={styles.infoSubtitle}>
          {t('VolunteerListScreen.check_in_out_info.subtitle', 'Only event organizers have access to this function.')}
        </p>

        <div className={styles.infoSection}>
          <div className={styles.infoItem}>
            <div className={`${styles.infoIcon} ${styles.signedUp}`}>
              <Icon name="clock" />
            </div>
            <div className={styles.infoContent}>
              <h6 className={styles.infoTitle}>
                {t('VolunteerListScreen.check_in_out_info.signed_up_title', 'Signed Up')}
              </h6>
              <p className={styles.infoDescription}>
                {t('VolunteerListScreen.check_in_out_info.signed_up_description', 'An individual has signed up to volunteer.')}
              </p>
            </div>
          </div>

          <div className={styles.infoItem}>
            <div className={`${styles.infoIcon} ${styles.checkedIn}`}>
              <Icon name="clock" />
            </div>
            <div className={styles.infoContent}>
              <h6 className={styles.infoTitle}>
                {t('VolunteerListScreen.check_in_out_info.checked_in_title', 'Checked In')}
              </h6>
              <p className={styles.infoDescription}>
                {t('VolunteerListScreen.check_in_out_info.checked_in_description', 'At the start of the volunteer activity, tap on the icon to Check In that person. The icon turns GREEN indicating that the volunteer is active.')}
              </p>
            </div>
          </div>

          <div className={styles.infoItem}>
            <div className={`${styles.infoIcon} ${styles.checkedOut}`}>
              <Icon name="clock" />
            </div>
            <div className={styles.infoContent}>
              <h6 className={styles.infoTitle}>
                {t('VolunteerListScreen.check_in_out_info.checked_out_title', 'Checked Out')}
              </h6>
              <p className={styles.infoDescription}>
                {t('VolunteerListScreen.check_in_out_info.checked_out_description', 'At the conclusion of the volunteer activity, tap on the icon to Check Out the volunteer. The icon turns PINK indicating that the volunteer is no longer active.')}
              </p>
            </div>
          </div>

          <div className={styles.infoItem}>
            <div className={`${styles.infoIcon} ${styles.rateVolunteer}`}>
              <Icon name="star" />
            </div>
            <div className={styles.infoContent}>
              <h6 className={styles.infoTitle}>
                {t('VolunteerListScreen.check_in_out_info.rate_volunteer_title', 'Rate Volunteer')}
              </h6>
              <p className={styles.infoDescription}>
                {t('VolunteerListScreen.check_in_out_info.rate_volunteer_description', 'Once the volunteer is Checked Out, you will be asked to Rate the Volunteer. You have the option of rating the volunteer in the moment or at a later time. The icon will only appear once the volunteer has been rated. The check out button is an active button to open the rating screen when owner has chosen to do it later.')}
              </p>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t('buttons.close')}
        </Button>
      </Modal.Footer>
    </Modal>
    </>
  )
}

